// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import { DragDropContext } from "react-beautiful-dnd";
import { Toastr } from "@revvsales/components";

// Components Imports
import KanbanSwimlane from "../KanbanSwimlane";

// Actions Imports
import { KanbanActions } from "../../../actions";

// Service Imports

// Internal Imports
import { AmplitudeUtils } from "../../../utils";
import { EVENTS } from "../../../constants";

// Destructuring
const { amplitudeLogEvent } = AmplitudeUtils;

const { updateDocumentStatus } = KanbanActions;

class KanbanWrapper extends Component {
  state = {};

  _onDragEnd = result => {
    const { source, destination, draggableId } = result;
    if (
      source &&
      destination &&
      source.droppableId !== destination.droppableId
    ) {
      this.props
        .updateDocumentStatus(
          destination.droppableId,
          source.droppableId,
          draggableId,
          this.props.kanbanStatusMap[destination.droppableId].id,
        )
        .then(() => {
          amplitudeLogEvent(EVENTS.EVENT_NAMES.STATUS_CHANGED, {
            initiatedFrom: "Kanban",
            oldStatus: source.droppableId,
            newStatus: destination.droppableId,
            documentID: draggableId,
            tag: "",
          });
        })
        .catch(() => {
          Toastr.showToastr({
            type: "failure",
            message: `Oops, something went wrong. Please try again.`,
            timeout: 3000,
          });
        });
    }
  };

  render() {
    console.debug("KANBAN", this.props);
    const { kanbanDocs, assetStatusList } = this.props;
    return (
      <DragDropContext onDragEnd={this._onDragEnd}>
        <div className="kanbanwrapper">
          {/* -------- Pipeline Right Section -------- */}
          <div className="kanbanoppurtunity-wrapper kanbanoppurtunity-full-width">
            {/* -------- Pipeline Right Header Section -------- */}

            {/* -------- Pipeline Swimlane Section -------- */}
            <div className="kanbancolumns-wrap">
              <div className="kanbancolumns">
                {Object.keys(kanbanDocs).length > 0
                  ? assetStatusList.map(status => (
                      <KanbanSwimlane
                        status={status}
                        docs={kanbanDocs[status.name] || []}
                      />
                    ))
                  : null}
              </div>
            </div>
          </div>
        </div>
      </DragDropContext>
    );
  }
}

const mapStateToProps = state => {
  const { kanbanDocs, kanbanStatusMap } = state.KanbanStore;
  const assetStatusList = state.AssetStore.assetStatusList
    ? state.AssetStore.assetStatusList
    : [];
  return { kanbanDocs, kanbanStatusMap, assetStatusList };
};

const mapDispatchToProps = {
  updateDocumentStatus: (newStatus, oldStatus, docID, newStatusID) =>
    updateDocumentStatus(newStatus, oldStatus, docID, newStatusID),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(KanbanWrapper);



// WEBPACK FOOTER //
// ./src/components/Kanban/KanbanWrapper/KanbanWrapper.js